export default {
  letterSpacing: {
    trackingTight: "0em",
    trackingNormal: "0.02em",
  },
};
